<template>
  <div class="exam-card">
    <div class="tags">
      <div class="tag on" v-if="content.status === 1"><span>已发布</span></div>
      <div class="tag off" v-if="content.status === 0"><span>未发布</span></div>
    </div>
    <div class="sorts">
      <el-button circle size="mini" icon="el-icon-back" :disabled="noUp" title="排序前" @click="handleSortChange(content, 'up')"></el-button>
      <el-button circle size="mini" icon="el-icon-right" :disabled="noDown" title="排序后" @click="handleSortChange(content, 'down')"></el-button>
    </div>
    <div class="content-wrap">
      <div class="left">
        <img :src="content.picture_url">
      </div>
      <div class="right">
        <p class="title">{{content.name}}</p>
        <div class="count">
          <span>共计{{content.item_count || 0}}题</span>
        </div>
        <div class="spacer"></div>
        <div class="price">
          <span class="new">¥{{content.price}}</span>
          <span class="old">¥{{content.market_price}}</span>
        </div>
      </div>
    </div>
    <div class="item-footer">
      <span class="subject-name" :title="(content.subjects && content.subjects.length) ? content.subjects[0].name : ''">{{(content.subjects && content.subjects.length) ? content.subjects[0].name : ''}}</span>
      <span class="member-count">{{content.user_count}}开通</span>
    </div>
    <div class="menu">
      <div class="menu-item">
        <router-link :to="`/read/detail/${content.id}`">
          <i class="el-icon-edit"></i>
          <span>编辑</span>
        </router-link>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handleToPreview">
        <i class="el-icon-zoom-in"></i>
        <span>浏览</span>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handelExamRemove">
        <i class="el-icon-delete"></i>
        <span>删除</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'exercise-card',
  props: {
    content: {
      type: Object,
      default: () => {return {}}
    },
    noUp: false,
    noDown: false
  },
  data() {
    return {}
  },
  methods: {
    handelExamRemove() {
      this.$emit('remove', this.content.id)
    },
    // 预览
    handleToPreview() {
      // if (this.content && this.content.subjects && this.content.subjects[0]) {
      //   if (location.host.includes('admin.koudaikaoyan.com')) {
      //     window.open(`https://www.koudaikaoyan.com/subject/${this.content.subjects[0].id}/read/${this.content.id}`)
      //   } else {
      //     window.open(`http://test.koudaikaoyan.com/subject/${this.content.subjects[0].id}/read/${this.content.id}`)
      //   }
      // }
    },
    // 排序位置变化
    handleSortChange(row, sort) {
      this.$emit('sort', row, sort)
    },
  }
}
</script>

<style lang="less" scoped>
.exam-card {
  position: relative;
  width: 260px;
  color: #303133;
  background-color: #FFF;
  border: 1px solid #EBEEF5;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  border-radius: 4px;
  padding: 30px 10px 0px;
  overflow: hidden;

  &:hover {
    .sorts {
      display: block;
    }
  }

  .tags {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;

    .tag {
      background: #ff6600;
      border-radius: 4px;
      border-top-right-radius: 0px;
      border-bottom-left-radius: 0px;
      font-size: 12px;
      color: #fff;
      padding: 3px 10px;

      &:not(:first-child) {
        margin-left: 5px;
      }
      &.on {
        background: #409EFF;
      }
    }
  }

  .sorts {
    display: none;
    position: absolute;
    right: 5px;
    top: 2px;

    button {
      padding: 2px;
    }
  }

  .content-wrap {
    display: flex;

    .left {
      margin-right: 10px;
    }
    .right {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: hidden;
    }
    img {
      display: block;
      width: 80px;
      height: 80px;
      object-fit: cover;
    }
    .title {
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
    }
    .count {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      font-size: 12px;
    }
    .spacer {
      flex: 1;
    }
    .price {
      display: flex;
      align-items: flex-end;
      font-weight: bold;
      font-size: 16px;

      .new {
        color: #f00;
      }
      .old {
        text-decoration: line-through;
        font-size: 12px;
        font-weight: normal;
        color: #999;
        margin-left: 3px;
      }
    }
    .title {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .item-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #666;
    margin-top: 10px;

    .subject-name {
      flex: 1;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
    }
    .member-count {
      margin-left: 10px;
    }
  }
  a {
    text-decoration: none;
  }
  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;
    margin: 10px -10px 0;

    .menu-item {
      display: flex;
      justify-content: center;
      cursor: pointer;
      padding: 10px 20px;

      i {
        margin-right: 2px;
      }
    }
    .divider {
      height: 20px;
      border-right: 1px solid #ccc;
    }
  }
}
</style>
